export const websalesApp = {
  id: 100,
  // Technical type name — must match the backend directory name (CONNECT-6928/6930 review):
  // resources/external_apps/scm_app_form_config/websales/ and modules/SalesChannel/Database/data/websales/.
  // FormProviderController builds that path directly from this value.
  name: "websales",
  label: "WEBSALE",
  showTestConnection: false,
  // WEBSALE has no single-call endpoint that answers with just an API key: the wizard would need
  // POST admin/api/v1/login, then GET admin/user/self with the returned token. The ADR-040 backend
  // recipe for that two-step flow is CONNECT-6926 (in progress) — until it lands, credentialsTestSupported
  // is false and there is no local additional_params to fall back to (same reasoning as temuApp.js).
  logo: process.env.BASE_URL + "media/shopLogos/websales.png",
  // No legacy WEBSALE interface to migrate from (CONNECT-6915). No journal/CFL sync flow in the MVP
  // scope (Sales Order, Order state & Tracking, Artikel, Stock, Preise) — nothing to report on yet.
  areaBlacklist: ["migration", "journal"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_WEBSALES_PRESET_ID,
    testWorkflows: {
      product: process.env?.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      salesOrder: process.env?.VUE_APP_SCM_APP_WEBSALES_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_WEBSALES_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID
    }
  }
};
